import { styled } from "@mui/system";
import { Box } from "@mui/material";
import rotatedBg from "../../../../../assets/backgrounds/Wallpaper.png";

// Setting up the background container with a basic full-screen background
export const BackgroundContainer = styled(Box)({
    height: "100vh",
    width: "100vw",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundImage: `url(${rotatedBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
});

export const LogoContainer = styled(Box)({
    position: "absolute",
    top: "20px",
    left: "20px",
    display: "flex",
    alignItems: "center",
    zIndex: 1,
});

export const CenterBox = styled(Box)({
    width: "390px",
    height: "auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
});
